import styled from 'styled-components'

import { Color } from '../../theme/color'

interface DivideLineProps {
  isShort?: boolean
  space?: number
}

export function DivideLine({ isShort, space }: DivideLineProps) {
  return <StyleDivideLine short={isShort} space={space} />
}

const StyleDivideLine = styled.div<{ short?: boolean; space?: number }>`
  border-bottom: 1px solid ${Color.line};
  ${({ short, space }) => (short ? '' : `margin: 0 ${space ?? 20}px;`)}
`
